import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'
// import orderRouter from './order'

const orderStatisticsManageRouter = { // 订单统计管理
  path: '/orderStatistics',
  component: Layout,
  redirect: 'orderStatisticsManage',
  meta: {
    title: '订单统计管理',
    icon: 'statistics',
    roles: ['agent']
  },
  children: [
    {
      path: 'TransactionStatistics',
      component: resolve => require(['@/views/agent/orderStatisticsManage/TransactionStatistics'], resolve),
      name: 'TransactionStatistics',
      meta: { title: '充值订单统计', noCache: false }
    },
    {
      path: 'PaidStatistics',
      component: resolve => require(['@/views/agent/orderStatisticsManage/PaidStatistics'], resolve),
      name: 'PaidStatistics',
      meta: { title: '提现订单统计', noCache: false }
    },
    {
      path: 'frozenOrder',
      component: resolve => require(['@/views/agent/orderStatisticsManage/frozenOrder'], resolve),
      name: 'FrozenOrder',
      meta: { title: '冻结订单统计', noCache: false }
    }
  ]
}

export default orderStatisticsManageRouter



// WEBPACK FOOTER //
// ./src/router/agent/orderStatisticsManage.js